module.exports = __webpack_public_path__ + "static/media/amount.5ae995be.svg";